module.exports = __webpack_public_path__ + "static/media/logo_footer.67164b39.png";